'use client';
import { useEffect } from 'react';

export const MeetingsScheduler = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.type = 'text/javascript';
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      data-test-calendly-meeting-component
      className="calendly-inline-widget min-w-full"
      data-url="https://calendly.com/skybeam-team/skybeam-demo"
      style={{ minHeight: '700px' }}
    />
  );
};
